<template>
  <Container :class="$style.container">
    <Card :class="$style.chartCard">
      <OsEventsGraph
        :customChartHeight="220"
        minTitle
        showOsFilter
        showTimeFrame
      />
    </Card>
    <Card :class="$style.releasesCard">
      <Card :class="$style.cardFullHeight">
        <OsReleasePatchTabs showTitle />
      </Card>
    </Card>
  </Container>
</template>

<script>
import {
  Card,
  Container,
} from '@jumpcloud/ui-components';
import OsEventsGraph from 'client/systems/OsEventsGraph';
import OsReleasePatchTabs from 'client/OsManagement/OsReleasePatch/OsReleasePatchTabs';

export default {
  name: 'CurrentOsReleaseTrains',

  components: {
    Container,
    Card,
    OsEventsGraph,
    OsReleasePatchTabs,
  },
};
</script>

<style module>

.container.container {
  display: flex;
  margin: 0;
  padding: 0;
}

.chartCard.chartCard {
  border-right: none;
  flex: 0 0 50%;
}

.chartCard.chartCard.chartCard section {
  padding: 0;
}

.releasesCard.releasesCard {
  border-left: none;
}

.cardFullHeight {
  height: 100%;
}

</style>
